import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface AdminTeamLeaveStepIndicatorProps {
  wasLastAdmin?: boolean
}

export const AdminTeamLeaveStepIndicator = React.memo(
  ({ wasLastAdmin }: AdminTeamLeaveStepIndicatorProps) => {
    const { t } = useTranslation()

    return (
      <div className="team-leave-overlay__update-admin-indicator">
        <div className="team-leave-overlay-update-admin__step">
          <div
            className={classNames(
              "team-leave-overlay-update-admin__icon-wrapper",
              { done: wasLastAdmin }
            )}
          >
            <Icon
              name={wasLastAdmin ? IconName.CHECK : IconName.USERS}
              size={IconSize.MEDIUM}
            />
          </div>
          {t("Team.Actions.UpdateAdmin")}
        </div>

        <div
          className={classNames("team-leave-overlay-update-admin__divider", {
            done: wasLastAdmin
          })}
        />

        <div className="team-leave-overlay-update-admin__step">
          {wasLastAdmin ? (
            <div className="team-leave-overlay-update-admin__icon-wrapper">
              <Icon name={IconName.LOGOUT_LEFT} size={IconSize.MEDIUM} />
            </div>
          ) : (
            <Icon name={IconName.LOGOUT_LEFT} size={IconSize.MEDIUM} />
          )}

          {t("Team.Actions.Leave")}
        </div>
      </div>
    )
  }
)
